import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Modal from '../atoms/modal';
import LoadingSpinner from '../atoms/loading-spinner';
import UserState from '../../data-containers/user';

// this version displays the content inline via shared
export const EulaContent = () => {
  const [EulaHTML, setEulaHTML] = useState(null);

  const loadContent = async () => {
    const html = await import('shared/documents/eula.html');
    setEulaHTML(html);
  };

  useEffect(
    () => {
      loadContent();
    },
    []
  );

  if(!EulaHTML){
    return <LoadingSpinner className="inline" />;
  }

  return <div className="eula-content" dangerouslySetInnerHTML={{ __html: EulaHTML }} />
}

export const EulaContentLinksOnly = () => {
  return <div className="eula-content eula-content-links">
    I agree to the <strong>CURB’s Terms &amp; Conditions</strong> (<a target="_blank" rel="noopener noreferrer" href="http://energycurb.com/terms">energycurb.com/terms</a>) <br/> and <strong>Privacy Policy</strong> (<a target="_blank" rel="noopener noreferrer" href="https://energycurb.com/privacy">energycurb.com/privacy</a>).
  </div>;
}

export const EulaContentWithUserProps = (props) => {
  const { close, updateAdminUserDetail } = props;

  const onClickConfirm = () => {
    updateAdminUserDetail({accepted_eula: true});
    close();
  }

  return <React.Fragment>
    {/* 
      <EulaContent />  
    */}
    <EulaContentLinksOnly />
    <div className="modal-footer curb-submit button-list">
      <Link to="/logout" className="button irreversible">Decline (logout)</Link>
      <button className="large confirm" onClick={onClickConfirm}>I accept</button>      
    </div>
  </React.Fragment>;
}

export default function(props){
  const { updateAdminUserDetail } = UserState.useContainer();
  return <Modal
    className="eula-modal"
    omitClose={true}
    sticky={true}
    updateAdminUserDetail={updateAdminUserDetail}
    render={EulaContentWithUserProps}    
    {...props} />;
}